"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var InputLabel_1 = __importDefault(require("@material-ui/core/InputLabel"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var Errors = function (props) {
    var name = props.name, errors = props.errors;
    if (!errors || !name || !(name in errors)) {
        return null;
    }
    var errorArr = errors[name];
    var errorMsg = errorArr.join(', ');
    return (react_1["default"].createElement(FormHelperText_1["default"], { style: { fontSize: 14, color: 'red' } }, errorMsg));
};
var OptionalLabel = function () { return (react_1["default"].createElement(Typography_1["default"], { component: "span", style: { fontSize: '0.85em' } },
    ' ',
    "(Optional)")); };
var Label = function (props) {
    var label = props.label, mandatory = props.mandatory, name = props.name, shrink = props.shrink;
    if (!label) {
        return null;
    }
    return (react_1["default"].createElement(InputLabel_1["default"], { htmlFor: name, shrink: shrink },
        label,
        !mandatory && react_1["default"].createElement(OptionalLabel, null)));
};
var Wrapper = function (props) {
    var label = props.label, name = props.name, errors = props.errors, _a = props.mandatory, mandatory = _a === void 0 ? true : _a, children = props.children, _b = props.inline, inline = _b === void 0 ? false : _b, inputId = props.inputId, shrink = props.shrink, _c = props.type, type = _c === void 0 ? 'default' : _c;
    var strName = name.toString();
    var control = (react_1["default"].createElement(StyledFormControl, { fullWidth: true, label: label },
        react_1["default"].createElement(Label, { name: inputId ? inputId : strName, label: label, shrink: shrink, mandatory: mandatory }),
        children,
        react_1["default"].createElement(Errors, { name: strName, errors: errors })));
    if (type === 'checkbox' || type === 'switch') {
        control = (react_1["default"].createElement(StyledFormControl, { fullWidth: true, label: label, style: { display: 'inline-block' } },
            react_1["default"].createElement(FormLabel_1["default"], null,
                label,
                !mandatory && react_1["default"].createElement(OptionalLabel, null),
                children),
            react_1["default"].createElement(Errors, { name: strName, errors: errors })));
    }
    if (type === 'date' || type === 'autocomplete') {
        control = (react_1["default"].createElement(StyledFormControl, { fullWidth: true, label: label },
            react_1["default"].cloneElement(children, {
                label: mandatory ? label : label + ' (Optional)'
            }),
            react_1["default"].createElement(Errors, { name: strName, errors: errors })));
    }
    if (inline) {
        return control;
    }
    else {
        return react_1["default"].createElement(FormControlWrapper, null, control);
    }
};
var StyledFormControl = styled_components_1["default"](FormControl_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: initial !important;\n  ", "\n"], ["\n  z-index: initial !important;\n  ",
    "\n"])), function (props) {
    return props.label &&
        "\n    label {\n      padding-left: 10px;\n    }\n  ";
});
var FormControlWrapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 15px;\n"], ["\n  margin-bottom: 15px;\n"])));
exports["default"] = Wrapper;
var templateObject_1, templateObject_2;
